import { render, staticRenderFns } from "./bodyMsg.vue?vue&type=template&id=345f9bb5&scoped=true&"
import script from "./bodyMsg.vue?vue&type=script&lang=js&"
export * from "./bodyMsg.vue?vue&type=script&lang=js&"
import style0 from "./bodyMsg.vue?vue&type=style&index=0&id=345f9bb5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f9bb5",
  null
  
)

export default component.exports